<!-- is revoked warning -->
<div *ngIf="(entity$  | async).isRevoked"
     class="alert alert-warning d-flex align-items-center justify-space-between">
  <fa-icon [fixedWidth]="true" [icon]="faExclamationTriangle" class="me-2"></fa-icon>
  <div
    class="w-100 flex-grow-1">{{ 'core-portal.settings.invitations.descriptions.invitation-is-revoked' | translate }}
  </div>
</div>


<ng-template #entityEditTemplate
             let-id="id"
             let-title="title">
  <app-settings-invitations-edit #modelComponent
                                        (modelChange)="onModelChange($event)"
                                        [creating]="false"
                                        [id]="id"
                                        [loading]="loading$ | async"
                                        [model]="model$ | async"
                                        [readonly]="readonly$ | async"
                                        [stereotyped]="false"
                                        [title]="title">
  </app-settings-invitations-edit>
</ng-template>

<app-entity-detail [entityDetailBaseComponent]="this"
                          [entityEditTemplate]="entityEditTemplate"
                          [tabCommands]="['.']"
                          [tabHeading]="title | translate"
                          tabId="invitations">

  <!-- Log Entries Tab -->
  <ng-template (selectTab)="onNavigateToTab(['contacts'])"
               *ngIf="model$ | async"
               [heading]="'core-portal.settings.invitations.titles.contact-list' | translate"
               [lazy]="true"
               appTabTemplate
               tabId="contacts">
    <app-settings-invitations-contact-list *ngIf="passedIds"
                                                  [isEmbedded]="true"
                                                  [parentIds]="passedIds">
    </app-settings-invitations-contact-list>
  </ng-template>
</app-entity-detail>
